const theme = {
    colors:{
        primary: "#B696CF",
        secondary:"pink"
    },
    size:{
        sm :{
            fontSize : "0.8rem", 
            padding: "0.2rem 0.5rem"
        },
        md:{
            fontSize: "1rem",
            padding: "0.5rem 1rem"
        },
        lg: {
            fontSize: "1.3rem", 
            padding: "0.5rem 1rem"
        }
    }
};

export default theme;